
export const landingPageConfig = {
  appConfig: {

    logo: '/assets/images/logo.png',

    breadcrumb: [
      { label: 'Home', url: 'https://www.learnzapp.com' },
      { label: 'FINRA Securities Certifications' }
    ],
    navItems: [
      { label: 'Home', url: '#home' },
      { label: 'Download', url: '#download' },
      { label: 'Features', url: '#features' },
      { label: 'Screenshots', url: '#screenshots' },
      { label: 'Pricing', url: '#pricing' }
    ],
    hero: {
      title: 'Master FINRA Securities Exams',
      subtitle1: 'Comprehensive SIE, Series 6, Series 7, Series 63, Series 65, and Series 66 exam preparation with adaptive learning, detailed analytics, and expert-crafted content.',
      subtitle2: 'Start studying smarter today.',
      stats: [
        { value: '10K+', label: 'Active Users', icon:'users'},
        { value: '95%', label: 'Pass Rate', icon:'trophy' },
        { value: '5000+', label: 'Practice Questions', icon:'question-circle' }
      ],
      appIcon: '/assets/images/app-icon.png',
      heroImage: '/assets/images/hero-image.png',
      heroImageDark: '/assets/images/hero-image-dark.png',

    },
    studyAnywhere: {
      title: 'Study Anywhere',
      subtitle: 'Your progress syncs across all your devices - phones, tablets, and web. Start studying on your phone during your commute and continue on your laptop browser at home.',
    },

    downloadLinks: [
      {
        store: 'Apple',
        title: 'App Store',
        url: 'https://apps.apple.com/app/id6444195133'
      },
      {
        store: 'Google',
        title: 'Google Play',
        url: 'https://play.google.com/store/apps/details?id=com.learnzapp.securities'
      }
    ]
  },

  featuresData: {
    title: 'Everything You Need to Succeed',
    subtitle: 'Comprehensive study tools designed specifically for FINRA Securities certification success',

      "items": [
        {
          "icon": "chart-line",
          "title": "Readiness Score Analytics",
          "description": "Track your overall readiness and domain-specific performance with detailed analytics. See exactly where you stand and what to focus on next."
        },
        {
          "icon": "file-text",
          "title": "Study Questions & Flashcards",
          "description": "Expert-written practice questions covering key exam topics with detailed explanations. Reinforce concepts with flashcards."
        },
        {
          "icon": "tools",
          "title": "Custom Test Builder",
          "description": "Create personalized practice tests by selecting specific domains, difficulty levels, and question counts. Study exactly what you need."
        },
        {
          "icon": "calendar-day",
          "title": "Question of the Day",
          "description": "Build your study streak with daily questions. Track your progress and maintain momentum with just 2 minutes a day."
        },
        {
          "icon": "users",
          "title": "Community Insights",
          "description": "See how other exam candidates answered each question. Learn from the community and understand common mistakes."
        },
        {
          "icon": "sync",
          "title": "Seamless Sync",
          "description": "Study on web, iOS, or Android. Your progress syncs automatically across all devices. Pick up exactly where you left off."
        },
        {
          "icon": "book",
          "title": "Comprehensive Resources",
          "description": "Flashcards, glossary, acronyms, and study guides. Everything you need in one place with regular content updates."
        },
        {
          "icon": "moon",
          "title": "Adaptive Interface",
          "description": "Dark/light mode support and responsive design. Study comfortably any time of day on any device."
        }
      ]

  },
  platforms: [
    {
      icon: 'laptop',
      title: 'Web Platform',
      description: 'Full-featured experience in your browser. Perfect for focused study sessions with detailed analytics.',
      ctaText: 'Sign In to Web App',
      ctaLink: 'https://app.learnzapp.com',
    },
    {
      icon: 'mobile-alt',
      title: 'Mobile Apps',
      description: 'Study on-the-go with native iOS and Android apps. Download for offline access and push notifications.',
      ctaText: 'Download Mobile App',
      ctaLink: '#downloads',
    },
    {
      icon: 'bullseye',
      title: 'Diagnostic Test',
      description: 'Not sure where to start? Take our free diagnostic test to assess your current knowledge and get a personalized study plan.',
      ctaText: 'Take Diagnostic Test',
      ctaLink: '#diagnostic',
    },
  ],

  screenshotsData: {
    title: "See It In Action",
    subtitle: "Explore our app's powerful features through these interactive screenshots",
    slides: []
  },

  certificationData: {
    title: 'FINRA Securities Certifications',
    subtitle: 'Prepare for all major FINRA securities exams',
    items: [
      {
        title: 'SIE - Securities Industry Essentials',
        domains: [
          'Customer Accounts',
          'Debt Securities',
          'Economics',
          'Equity Securities',
          'Investment Companies',
          'Issuing Securities',
          'Retirement Plans & Annuities',
          'Trading Securities',
          'Recommendations & Ethics',
          'Options',
          'Rules and Regulations'
        ],
        requirements: [
          'No prerequisite - open to anyone 18+',
          'Pass the SIE exam'
        ],
        experience: 'No prior experience required',
        benefits: [
          'Entry point for securities industry careers',
          'Required for most FINRA representative registrations',
          'Demonstrates foundational securities knowledge'
        ],
        exam: {
          duration: '1 hour 45 minutes',
          questions: '75 multiple-choice questions',
          passingScore: '70%'
        }
      }
    ]
  },

  contactData: {
    title: 'Contact Us',
    subtitle: 'Have questions? We\'re here to help'
  },

  footerData: {
    logo: '/assets/images/logo.png',
    description: 'Your trusted partner for FINRA Securities certification exam preparation',
    socialLinks: [{
      url: 'https://www.linkedin.com/company/learnzapp',
      icon: '/assets/images/linkedin-icon.png'
    }],
    examLinksTitle: 'LearnZapp Exam Prep Apps',
    examLinks: [
      {
        name: 'ISC2 Official App',
        details: 'CISSP, CCSP and SSCP',
        icon: '/assets/images/app-icons/isc2.png',
        url: 'https://isc2.learnzapp.com'
      },
      {
        name: 'ISACA Official App',
        details: 'CISA and CISM',
        icon: '/assets/images/app-icons/isaca.png',
        url: 'https://isaca.learnzapp.com'
      },
      {
        name: 'Cisco Exam Prep',
        details: 'CCNA and CCNP',
        icon: '/assets/images/app-icons/cisco.png',
        url: 'https://cisco.learnzapp.com'
      },
      {
        name: 'CompTIA Certifications',
        details: 'Security+, A+, Network+ and more',
        icon: '/assets/images/app-icons/comptia.png',
        url: 'https://comptia.learnzapp.com'
      }
    ],
    copyright: '© 2023 LearnZapp. All rights reserved.',
    footerLinks: [
      { name: 'Privacy Policy', url: '#' },
      { name: 'Terms of Service', url: '#' },
      { name: 'Contact', url: '#' },
      { name: 'Support', url: '#' }
    ]
  },

  keyStats: {
    items: [
      {
        number: '5000',
        label: 'Study Questions'
      },
      {
        number: '500',
        label: 'Flashcards'
      },
      {
        number: '800',
        label: 'Glossary Terms'
      }
    ]
  },

  faqData: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our certification preparation platform',
    faqs: [
      {
        question: 'What exams do you support?',
        answer: 'We support all major FINRA securities exams: SIE (Securities Industry Essentials), Series 6, Series 7, Series 63, Series 65, and Series 66. Our platform provides comprehensive study materials and practice questions for each exam.'
      },
      {
        question: 'How does the adaptive learning system work?',
        answer: 'Our adaptive learning system analyzes your performance across different domains and topics, identifying your strengths and areas for improvement. It then customizes your study plan, focusing on topics where you need more practice while reinforcing your strong areas.'
      },
      {
        question: 'Can I access the platform on multiple devices?',
        answer: 'Yes! Our platform is available on web browsers, iOS, and Android devices. Your progress automatically syncs across all devices, allowing you to study seamlessly whether you\'re at home or on the go.'
      },
      {
        question: 'What\'s included in the subscription plans?',
        answer: 'All subscription plans include access to our complete question bank, study materials, analytics dashboard, and practice tests. Longer-term plans offer additional savings and may include premium features like detailed performance analytics and personalized study recommendations.'
      },
      {
        question: 'How often is the content updated?',
        answer: 'We regularly update our content to align with the latest exam changes and industry best practices. Our team of certified professionals reviews and updates questions and study materials to ensure they reflect current exam requirements.'
      },
      {
        question: 'Do you offer a money-back guarantee?',
        answer: 'Yes, we offer a 7-day money-back guarantee for our subscription plans. If you\'re not satisfied with our platform, you can request a full refund within the first 7 days of your subscription.'
      }
    ]
  }
};
